import React from "react";
import { Link } from "react-router-dom";

/**
 * Usuario autenticado pero sin rol de administración (admin/moderator).
 * No montamos el layout del backoffice para evitar acceso indirecto.
 */
export default function StaffAccessDenied() {
	return (
		<div
			className="d-flex flex-column align-items-center justify-content-center"
			style={{ minHeight: "100vh", padding: 24, background: "#f4f6f9" }}
		>
			<div
				className="bg-white shadow-sm rounded p-8 text-center"
				style={{ maxWidth: 420, padding: "2rem" }}
			>
				<h1 className="h3 mb-4">Acceso denegado</h1>
				<p className="text-muted mb-6">
					Esta aplicación solo está disponible para administradores. Cierra sesión o usa una cuenta con permisos.
				</p>
				<Link to="/logout" className="btn btn-primary">
					Cerrar sesión
				</Link>
			</div>
		</div>
	);
}
